import { render } from "./HeroiconsOutlineArchive.vue?vue&type=template&id=5471da2e"
const script = {}

import exportComponent from "/Users/yllndritb/Projects/rent/rent-api/vendor/laravel/nova/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"HeroiconsOutlineArchive.vue"]])

export default __exports__